<template lang="pug">
  #tripMovementContainer()
    v-progress-linear(:indeterminate="$store.state.trips.isLoadingTrips")
    trip-movement-item(v-for="(trip,index) in $store.state.trips.trip_data" :key="index" :trip="trip" :selected="index==$store.getters['trips/getCurrentIndex']" :index="index" @selected="onSelected")
</template>
<script>
import TripMovementItem from "@/modules/maps/components/ui/SideBar/TripMovementItem";
export default {
  components: {
    TripMovementItem
  },
  data: () => ({}),

  mounted() {},
  methods: {
    onSelected(theIndex) {
      this.$store.commit("trips/setCurrentIndex", theIndex);
      this.$store.dispatch("trips/loadPath");
    }
  }
};
</script>
<style scoped lang="stylus">
#tripMovementContainer {
  
}
</style>
